(function() {
  var reviewPool = [
    { name: "Sarah Mitchell", initial: "S", rating: 5, title: "Perfect everyday ring", text: "I wear this ring every single day and it still looks brand new. The quality is exceptional and the engraving turned out beautifully. Worth every penny!", date: "November 13, 2025" },
    { name: "Emily Chen", initial: "E", rating: 5, title: "Beautiful craftsmanship", text: "The attention to detail is incredible. I was nervous about ordering jewelry online but this exceeded all my expectations. The packaging was also gorgeous!", date: "November 8, 2025" },
    { name: "Jessica Brown", initial: "J", rating: 4.5, title: "Beautiful ring, amazing engraving", text: "Beautiful ring and great quality. The engraving came out perfect and the finish looks even better in person. Arrived fast and packaged nicely. Highly recommend!", date: "October 26, 2025" },
    { name: "Michael Thompson", initial: "M", rating: 5, title: "Exceeded expectations", text: "Absolutely love this ring! The quality is outstanding and the engraving is crisp and clear. Fast shipping and excellent customer service.", date: "November 20, 2025" },
    { name: "Amanda Wilson", initial: "A", rating: 5, title: "Stunning piece", text: "This ring is absolutely gorgeous! The craftsmanship is top-notch and it feels so comfortable to wear. The personalization made it extra special.", date: "November 15, 2025" },
    { name: "David Martinez", initial: "D", rating: 5, title: "Perfect gift", text: "Bought this as an anniversary gift and my partner loves it! The engraving is beautiful and the ring itself is very well made. Highly satisfied!", date: "November 10, 2025" },
    { name: "Lisa Anderson", initial: "L", rating: 4.5, title: "Great quality", text: "Really impressed with the quality and attention to detail. The ring looks even better in person than in the photos. Shipping was super fast too!", date: "October 30, 2025" },
    { name: "Robert Taylor", initial: "R", rating: 5, title: "Amazing quality", text: "This is my second ring from them and I am just as happy as the first time. The quality is consistent and the engraving is always perfect.", date: "November 5, 2025" },
    { name: "Jennifer Lee", initial: "J", rating: 5, title: "Love it!", text: "Such a beautiful ring! The engraving came out exactly as I wanted and the ring itself is stunning. Will definitely order again!", date: "November 18, 2025" },
    { name: "Christopher Davis", initial: "C", rating: 5, title: "Perfect fit", text: "The sizing was perfect and the ring looks amazing. The engraving is clear and the overall quality is excellent. Very happy with my purchase!", date: "November 12, 2025" },
    { name: "Maria Garcia", initial: "M", rating: 5, title: "Beautiful and durable", text: "I have been wearing this ring daily for months and it still looks brand new. The quality is exceptional and the engraving is still crisp.", date: "October 28, 2025" },
    { name: "James White", initial: "J", rating: 4.5, title: "Great purchase", text: "Really happy with this ring. The quality is great and the personalization makes it unique. Fast shipping and great packaging.", date: "November 22, 2025" }
  ];
  
  function generateStars(rating) {
    var stars = "";
    var fullStars = Math.floor(rating);
    var hasHalf = rating % 1 >= 0.5;
    
    for (var i = 0; i < fullStars; i++) {
      stars += '<svg viewBox="0 0 24 24" fill="#fbbf24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    
    if (hasHalf) {
      stars += '<svg viewBox="0 0 24 24" fill="#fbbf24" style="opacity: 0.5;"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    
    var emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
    for (var i = 0; i < emptyStars; i++) {
      stars += '<svg viewBox="0 0 24 24" fill="#d4d4d4"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    
    return stars;
  }
  
  function renderReviews() {
    try {
      var reviewsGrid = document.querySelector(".tp-reviews-strip .tp-reviews-grid");
      if (!reviewsGrid) return;
      
      var shuffled = reviewPool.slice().sort(function() { return Math.random() - 0.5; });
      var selectedReviews = shuffled.slice(0, 3);
      
      var reviewsHTML = selectedReviews.map(function(review) {
        return "<div class=\"review-card\">" +
          "<div class=\"review-header\">" +
            "<div class=\"review-author-info\">" +
              "<div class=\"review-avatar\">" + review.initial + "</div>" +
              "<div>" +
                "<div class=\"review-author-name\">" + review.name + "</div>" +
                "<div class=\"review-verified\">" +
                  "<svg viewBox=\"0 0 20 20\" fill=\"currentColor\">" +
                    "<path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/>" +
                  "</svg>" +
                  "Verified Purchase" +
                "</div>" +
                "<div class=\"review-date\">" + review.date + "</div>" +
              "</div>" +
            "</div>" +
            "<div class=\"review-stars\">" + generateStars(review.rating) + "</div>" +
          "</div>" +
          "<h3 class=\"review-title\">" + review.title + "</h3>" +
          "<p class=\"review-text\">" + review.text + "</p>" +
          "<div class=\"review-divider\"></div>" +
        "</div>";
      }).join("");
      
      reviewsGrid.innerHTML = reviewsHTML;
    } catch (e) {
      // Silently fail if there's an error
    }
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderReviews);
  } else {
    renderReviews();
  }
  
  setTimeout(renderReviews, 100);
})();

